var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25781 12.2549L9.25781 15.2549L12.2578 12.2549",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25781 8.50488V15.2549",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9167 13.0723C16.5688 12.6138 17.0577 11.9594 17.3127 11.2042C17.5676 10.4489 17.5753 9.6321 17.3345 8.8722C17.0938 8.11231 16.6171 7.4489 15.9738 6.97825C15.3304 6.50761 14.5538 6.25421 13.7567 6.25483H12.8117C12.5862 5.37574 12.1641 4.55927 11.5773 3.86689C10.9905 3.17452 10.2543 2.62428 9.42413 2.2576C8.59393 1.89092 7.69136 1.71735 6.78437 1.74997C5.87738 1.78259 4.98961 2.02054 4.18789 2.4459C3.38617 2.87127 2.69139 3.47297 2.15587 4.2057C1.62034 4.93844 1.25801 5.78312 1.09617 6.67614C0.934327 7.56917 0.977182 8.48728 1.22151 9.36135C1.46584 10.2354 1.90527 11.0427 2.50672 11.7223",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.15600182c7684edafd962952b14208bc.svg";
export { ForwardRef as ReactComponent };